import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfaef5b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-6" }
const _hoisted_2 = { class: "col-lg-4 col-form-label fw-semobold fs-6" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = {
  class: "image-input image-input-outline",
  "data-kt-image-input": "true"
}
const _hoisted_5 = { class: "w-100 h-100 position-relative" }
const _hoisted_6 = {
  key: 0,
  class: "bi bi-pencil-fill fs-7"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-2" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]

import { computed, nextTick, ref } from "vue";
import blankImage2 from "@/assets/media/folder/blank-image.svg";
import clientSvc from "@/projects/client/services/ClientGlobalService";
import tenantSvc from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import JwtService from "@/core/services/JwtService";
import { useI18n } from "vue-i18n";
import { isMobile } from "@/core/config/WindowConfig";
import { FileFormatTypes } from "@/core/types/FileFormatTypes";
import VuePdfEmbed from "vue-pdf-embed";

const blankImage = "";

export default /*#__PURE__*/_defineComponent({
  __name: 'FileUploader',
  props: {
    side: { default: "client" },
    title: {},
    fileType: {},
    description: { default: "Files uploaded " },
    hint: {},
    disableDefaultUpload: { type: Boolean, default: false },
    partyId: {},
    handleFileUpload: {}
  },
  emits: ["fileUploaded"],
  setup(__props: any, { expose: __expose, emit: emits }) {

const props = __props;

const { t } = useI18n();



const isLoading = ref<boolean>(false);
const fileUploadInputRef = ref<any>();
const handleFileUploadIconClick = () => fileUploadInputRef.value.click();

const contentType = ref<FileFormatTypes>(FileFormatTypes.JPEG);
const previewUrl = ref<string>(blankImage); // used for preview image
let form = new FormData(); // the form of request body
const currentGuid = ref<string>(""); // the guid of current uploaded file
// emits to give back the guid of uploaded file for parent component


const onChangeFileHandler = async (e: Event) => {
  const target = e.target as HTMLInputElement;
  if (!target.files) return;
  const file = target.files[0];
  target.value = "";
  contentType.value =
    {
      ["application/pdf"]: FileFormatTypes.PDF,
      ["image/jpeg"]: FileFormatTypes.JPEG,
      ["image/jpg"]: FileFormatTypes.JPG,
      ["image/png"]: FileFormatTypes.PNG,
      ["text/plain"]: FileFormatTypes.TXT,
    }[file.type] ?? FileFormatTypes.JPEG;

  form.append("file", file);

  const reader = new FileReader();
  reader.onload = (e) => {
    console.log(e);
    previewUrl.value = (e.target as FileReader).result as string;
  };
  reader.readAsDataURL(file);

  const uploadFileFunc =
    props.handleFileUpload ??
    {
      client: clientSvc.uploadFile,
      tenant: tenantSvc.uploadFileToUser,
    }[props.side];

  if (props.disableDefaultUpload) {
    currentGuid.value = "-1";
    emits("fileUploaded", "-1", form);
    return;
  }

  // if uploadFileFunc is a promise
  // console.log("uploadFileFunc", typeof uploadFileFunc);
  if (typeof uploadFileFunc === "function") {
    try {
      const data = await uploadFileFunc(form, props.fileType, props.partyId);
      currentGuid.value = data.guid;

      if (props.partyId) {
        MsgPrompt.success(t("tip.submitSuccess")).then(() => {
          emits("fileUploaded", data.guid);
        });
      } else {
        emits("fileUploaded", data.guid);
      }
    } catch (err) {
      clearPreview();
    }
  } else {
    MsgPrompt.error("upload function not found");
  }
};

const removeImage = async () => {
  // console.log("remove image initiated", currentGuid.value);
  isLoading.value = true;
  previewUrl.value = blankImage;
  await nextTick();
  if (!currentGuid.value) return;
  form.delete("uploadedFile");

  if (!props.disableDefaultUpload) {
    const deleteFileFunc =
      {
        client: clientSvc.deleteMediaFileByGuid,
        tenant: tenantSvc.deleteMediaFileByGuid,
      }[props.side] ?? (() => -1);
    try {
      await deleteFileFunc(currentGuid.value);
    } catch (err) {
      MsgPrompt.error(err);
    }
  }
  currentGuid.value = "";
  isLoading.value = false;
};

// if default upload is disabled and there is an existing preview, disable delete func
// because the deleting func is always undefined
const disableRemoveImageFunc = computed(() => {
  return props.disableDefaultUpload && currentGuid.value === "-1";
});

const imageHasPreview = computed(() => previewUrl.value !== blankImage);

const clearPreview = () => {
  previewUrl.value = blankImage;
  form = new FormData();
};

const setPreviewByGuid = async (_guid: string) => {
  // console.log("setPreviewByGuid", props.guid);
  currentGuid.value = _guid;
  let img_src = "";
  img_src =
    window["api"] +
    "/api/api/v1/" +
    (props.side ? (props.side as string) : "tenant") +
    "/media/" +
    _guid +
    "?access_token=" +
    JwtService.getToken();
  previewUrl.value = img_src;
};

__expose({
  clearPreview,
  setPreviewByGuid,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(["image-input-wrapper overflow-hidden", {
            ' w-350px h-250px': !_unref(isMobile),
            ' w-300px h-200px': _unref(isMobile),
          }]),
              style: _normalizeStyle(
            previewUrl.value !== '' ? `background-image: url(${previewUrl.value})` : ''
          )
            }, [
              (
              [_unref(FileFormatTypes).PDF].includes(contentType.value) && imageHasPreview.value
            )
                ? (_openBlock(), _createBlock(_unref(VuePdfEmbed), {
                    key: 0,
                    source: previewUrl.value !== '' ? previewUrl.value : '',
                    class: "w-100 h-100"
                  }, null, 8, ["source"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, [
                (!imageHasPreview.value)
                  ? (_openBlock(), _createElementBlock("i", {
                      key: 0,
                      onClick: handleFileUploadIconClick,
                      class: "fa-solid fa-folder-plus fa-2xl position-absolute cursor-pointer",
                      style: {"color":"#d7e1ee","font-size":"12rem","top":"50%","left":"50%","transform":"translate(-50%, -50%)"}
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("label", {
                class: _normalizeClass({
              'btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow':
                imageHasPreview.value,
            }),
                "data-kt-image-input-action": "change",
                "data-bs-toggle": "tooltip",
                title: "Upload File"
              }, [
                (imageHasPreview.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                  : _createCommentVNode("", true),
                _createElementVNode("input", {
                  ref_key: "fileUploadInputRef",
                  ref: fileUploadInputRef,
                  type: "file",
                  name: "file",
                  accept: ".png, .jpg, .jpeg, .pdf, .heic",
                  onChange: onChangeFileHandler
                }, null, 544)
              ], 2)
            ], 6))
          : _createCommentVNode("", true),
        (imageHasPreview.value)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow",
              "data-kt-image-input-action": "remove",
              "data-bs-toggle": "tooltip",
              onClick: removeImage,
              title: "Remove avatar"
            }, _hoisted_8))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})